/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticPauseTemplate } from '../../models/automatic-pause-template';
import { AutomaticPauseType } from '../../models/automatic-pause-type';

export interface GetAllAutomaticPauseTemplates$Params {
  'Active-Tenant-Identifier': string;
  templateType?: AutomaticPauseType;
}

export function getAllAutomaticPauseTemplates(http: HttpClient, rootUrl: string, params: GetAllAutomaticPauseTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AutomaticPauseTemplate>>> {
  const rb = new RequestBuilder(rootUrl, getAllAutomaticPauseTemplates.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('templateType', params.templateType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AutomaticPauseTemplate>>;
    })
  );
}

getAllAutomaticPauseTemplates.PATH = '/ordering/automatic-pause-templates';
